import { ReactComponent as BackIcon } from '@paradigm/icons/src/mailru/navigation/arrow_list_next.svg';
import classNames from 'clsx';
import React, { memo } from 'react';
import { iconSize } from 'reactApp/ui/UploadList/Problems/CloseIcon';

import styles from './Problems.css';

interface IArrowsProps {
    fileIndex: number;
    fileLength: number;
    prevActive: boolean;
    nextActive: boolean;
    switchWarning: (params: { back: boolean; highlightFile: boolean }) => void;
}

export const Arrows = memo(({ fileIndex, fileLength, prevActive, nextActive, switchWarning }: IArrowsProps) => {
    const nextWarning = () => {
        switchWarning({ back: false, highlightFile: true });
    };

    const prevWarning = () => {
        switchWarning({ back: true, highlightFile: true });
    };

    return (
        <div className={styles.arrows}>
            <div
                className={classNames({
                    [styles.arrow]: true,
                    [styles.prevIcon]: true,
                    [styles.active]: prevActive,
                })}
                onClick={prevWarning}
            >
                <BackIcon {...iconSize} />
            </div>
            <div className={styles.counter}>
                {fileIndex + 1} / {fileLength}
            </div>
            <div className={classNames({ [styles.arrow]: true, [styles.active]: nextActive })} onClick={nextWarning}>
                <BackIcon {...iconSize} />
            </div>
        </div>
    );
});

Arrows.displayName = 'Arrows';
